import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardToursComponent } from './dashboard-tours/dashboard-tours.component';
import { ToursComponent } from './tours.component';
import { TourReservationComponent } from './tour-reservation/tour-reservation.component';
import { AuthGuardUser } from '../_helper/auth.guardUser';
import { TourExcursionComponent } from './tour-excursion/tour-excursion.component';
import { TourItineraryDetailComponent } from './tour-itinerary-detail/tour-itinerary-detail.component';
import { TourPassengersComponent } from './tour-passengers/tour-passengers.component';



const routes: Routes = [{
    path: '',
    component: ToursComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardToursComponent,
      },
      {
        path: 'reservation/:tourid',
        component: TourReservationComponent,
        canActivate: [AuthGuardUser]
      },
      {
        path: 'tour-excursion/:tourid',
        component: TourExcursionComponent,
        canActivate: [AuthGuardUser]
      },
      {
        path: 'tour-itinerary/:tourid',
        component: TourItineraryDetailComponent,
        canActivate: [AuthGuardUser]
      },
      {
        path: 'tour-passangers/:tourid',
        component: TourPassengersComponent,
        canActivate: [AuthGuardUser]
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        // otherwise redirect to home
        path: '**',
        redirectTo: 'tours',
      },
    ],
  }];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
  })
  export class ToursRoutingModule { }
